import { useNavigate } from "react-router-dom";
import { Button, Flex, Layout } from "antd";
import ReactPlayer from "react-player";

import { GET } from "../../../providers/useAxiosQuery";
import { useState } from "react";

export default function PageScoreCard() {
	const navigate = useNavigate();

	const [dataSource, setDataSource] = useState(null);

	GET(
		`api/formsur?from=Scorecard`,
		"formsur_scorecard",
		async (res) => {
			if (res && res.data) {
				let data = res.data;
				let findForm = data[0];

				if (findForm) {
					setDataSource(findForm);
				}
			}
		},
		false
	);

	return (
		<Layout.Content>
			<div className="main-content">
				<div className="logo-wrapper">
					<img
						src="/assets/joyalifevertical_green_on_white_transparent.png"
						alt="joyalifevertical_green_on_white_transparent.png"
					/>
				</div>

				{dataSource && dataSource.video_url ? (
					<Flex
						align="center"
						justify="center"
						className="react-player-wrapper"
					>
						<ReactPlayer src={dataSource.video_url} width={720} height={360} />
					</Flex>
				) : null}

				<div className="content-title">Welcome to your Joya Life Scorecard</div>

				<div className="content-description">
					<div className="text-center">
						Get a clear picture of your life today and where to go next.
					</div>
					<br />
					<div>
						The Joya happiness scorecard shows your strengths and weaknesses
						across 8 key areas of your life:
					</div>
					<br />
					<ul className="scorecard-list">
						<ol>
							<strong>WORK-LIFE:</strong> Achieve career success while
							maintaining work-life balance.
						</ol>
						<ol>
							<strong>RELATIONSHIPS:</strong> Strengthen your connections with
							loved ones or find a great match to share your life with.
						</ol>
						<ol>
							<strong>HOME:</strong> Design a home that reflects your personal
							style and meets your practical needs.
						</ol>
						<ol>
							<strong>HEALTH:</strong> Prioritise your physical and mental
							well-being to live a vibrant life.
						</ol>
						<ol>
							<strong>SENSE OF BELONGING:</strong> Build deep, meaningful
							relationships with family, friends, and community.
						</ol>
						<ol>
							<strong>RECREATION:</strong> Incorporate fun and joy into your
							life through hobbies and activities.
						</ol>
						<ol>
							<strong>HOLIDAYS:</strong> Plan and enjoy relaxing getaways that
							recharge your spirit.
						</ol>
						<ol>
							<strong>FINANCE:</strong> Take control of your financial future
							with expert guidance and resources.
						</ol>
					</ul>
				</div>

				<div className="footer-wrapper">
					<div>
						Once you finish, you'll see your results on a wheel that could be
						anything from:
					</div>
					<br />
					<div className="scorecard-wheel-examples">
						<div className="dot">•</div>
						<div>
							<strong>Big and Round:</strong> Life is great, helping others may
							be your focus.
						</div>
					</div>
					<div className="scorecard-wheel-examples">
						<div className="dot">•</div>
						<div>
							<strong>A Bit Wonky:</strong> Some areas can improve, with room
							for growth now or in the future.
						</div>
					</div>
					<div className="scorecard-wheel-examples">
						<div className="dot">•</div>
						<div>
							<strong>Small and Round:</strong> Lots of room to grow, but it may
							feel overwhelming.
						</div>
					</div>
				</div>

				<Button
					type="primary"
					onClick={() => {
						localStorage.removeItem("scorecardAnswers");
						navigate("/scorecard/form");
					}}
				>
					BEGIN ASSESSMENT
				</Button>
			</div>
		</Layout.Content>
	);
}
